export enum tiposBolsa {
    Interna = 1,
    Externa = 2,
}

export enum estadoBolsa {
    Ativo = 1,
    Inativo = 2,
    Suspenso = 3,
    Finalizado = 4,
    Pendente = 5
}

export enum niveisAcademicos {
    EnsinoPrimário = 1,
    EnsinoMedio = 2,   
    Bacharelato = 3,
    Licenciatura = 4,
    PosGraduacao = 5,
    Mestrado = 6,
    Doutoramento = 7,
    PosDoutoramento = 8,
}

